var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C8.41421 0 8.75 0.335786 8.75 0.75V2.25C8.75 2.66421 8.41421 3 8 3C7.58579 3 7.25 2.66421 7.25 2.25V0.75C7.25 0.335786 7.58579 0 8 0Z",
    fill: "#F9A01B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C8.41421 13 8.75 13.3358 8.75 13.75V15.25C8.75 15.6642 8.41421 16 8 16C7.58579 16 7.25 15.6642 7.25 15.25V13.75C7.25 13.3358 7.58579 13 8 13Z",
    fill: "#F9A01B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z",
    fill: "#F9A01B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6568 3.40386C13.9497 3.11096 13.9497 2.63609 13.6568 2.3432C13.3639 2.0503 12.889 2.0503 12.5961 2.3432L11.5355 3.40386C11.2426 3.69675 11.2426 4.17162 11.5355 4.46452C11.8284 4.75741 12.3032 4.75741 12.5961 4.46452L13.6568 3.40386Z",
    fill: "#F9A01B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46441 12.5962C4.7573 12.3034 4.7573 11.8285 4.46441 11.5356C4.17151 11.2427 3.69664 11.2427 3.40375 11.5356L2.34309 12.5962C2.05019 12.8891 2.05019 13.364 2.34309 13.6569C2.63598 13.9498 3.11085 13.9498 3.40375 13.6569L4.46441 12.5962Z",
    fill: "#F9A01B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.41421 15.6642 8.75 15.25 8.75H13.75C13.3358 8.75 13 8.41421 13 8C13 7.58579 13.3358 7.25 13.75 7.25H15.25C15.6642 7.25 16 7.58579 16 8Z",
    fill: "#F9A01B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8C3 8.41421 2.66421 8.75 2.25 8.75H0.75C0.335787 8.75 0 8.41421 0 8C0 7.58579 0.335787 7.25 0.75 7.25H2.25C2.66421 7.25 3 7.58579 3 8Z",
    fill: "#F9A01B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.596 13.6568C12.8889 13.9497 13.3638 13.9497 13.6567 13.6568C13.9496 13.3639 13.9496 12.889 13.6567 12.5961L12.596 11.5355C12.3031 11.2426 11.8283 11.2426 11.5354 11.5355C11.2425 11.8284 11.2425 12.3032 11.5354 12.5961L12.596 13.6568Z",
    fill: "#F9A01B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40363 4.46441C3.69653 4.7573 4.1714 4.7573 4.46429 4.46441C4.75719 4.17151 4.75719 3.69664 4.46429 3.40375L3.40363 2.34309C3.11074 2.05019 2.63587 2.05019 2.34297 2.34309C2.05008 2.63598 2.05008 3.11085 2.34297 3.40375L3.40363 4.46441Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sun-icon.9e46826a5ca11ed67c50e458850ca6b0.svg";
export { ForwardRef as ReactComponent };